<template>
  <b-card>
    <div
      v-if="dataLoad"
      class=" text-center my-2"
    >
      <b-spinner
        type="grow"
        label="Loading..."
      />
    </div>
    <span v-else>
      <b-row>
        <b-col md="6">
          <b-form-group
            label="Name Arabic"
            label-for="name-ar"
          >
            <b-form-input
              id="name-ar"
              v-model="certificateData.name_ar"
              trim
              placeholder="Name Arabic"
              :disabled="$route.params.id ? true : false"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Name English"
            label-for="name-en"
          >
            <b-form-input
              id="name-en"
              v-model="certificateData.name_en"
              trim
              placeholder="Name English"
              :disabled="$route.params.id ? true : false"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Description Arabic"
            label-for="descriptionAr"
          >
            <b-form-input
              id="descriptionAr"
              v-model="certificateData.description_ar"
              trim
              placeholder="Description Arabic"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">

          <b-form-group
            label="Description English"
            label-for="descriptionEn"
          >
            <b-form-input
              id="descriptionEn"
              v-model="certificateData.description_en"
              trim
              placeholder="Description English"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">

          <b-form-group
            label="Process Type"
            label-for="process_type"
          >
            <b-form-select
              id="process_type"
              v-model="certificateData.process_type"
              :options="optionsProcessType"
              trim
              placeholder="Process Type"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">

          <b-form-group
            label="Accountant Email"
            label-for="accountant-email"
          >
            <b-form-input
              id="name-en"
              v-model="certificateData.accountant_email"
              trim
              type="email"
              placeholder="Accountant Email"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">

          <b-form-group
            label="Proccess Time Days"
            label-for="proccess_time_days"
          >
            <b-form-input
              id="proccess_time_days"
              v-model="certificateData.proccess_time_days"
              trim
              type="number"
              placeholder="Proccess Time Days"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">

          <b-form-group
            label="Load"
            label-for="load"
          >
            <b-form-input
              id="load"
              v-model="certificateData.load"
              trim
              type="number"
              placeholder="Load"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Expiration Duration Months"
            label-for="expiration_duration_months"
          >
            <b-form-input
              id="expiration_duration_months"
              v-model="certificateData.expiratino_duration_months"
              trim
              type="number"
              placeholder="Expiration Duration Months"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="price"
            label-for="price"
          >
            <b-form-input
              id="price"
              v-model="certificateData.price"
              trim
              type="number"
              placeholder="price"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="require_approve"
            label-for="require_approve"
          >
            <b-form-select
              id="require_approve"
              v-model="certificateData.require_approve"
              :options="optionRequireApprove"
              trim
              placeholder="require_approve"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Need Dataentry"
            label-for="Need Dataentry"
          >
            <b-form-select
              id="need_dataentry"
              v-model="certificateData.need_dataentry"
              :options="optionNeedDataentry"
              trim
              placeholder="Need Dataentry"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="Accountant Avg Time In Hours"
            label-for="Accountant Avg Time In Hours"
          >
            <b-form-input
              id="accountant_avg_time_in_hours"
              v-model="certificateData.accountant_avg_time_in_hours"
              trim
              type="number"
              placeholder="Accountant Avg Time In Hours"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label="First Reviewer Avg Time In Hours"
            label-for="First Reviewer Avg Time In Hours"
          >
            <b-form-input
              id="first_reviewer_avg_time_in_hours"
              v-model="certificateData.first_reviewer_avg_time_in_hours"
              trim
              type="number"
              placeholder="First Reviewer Avg Time In Hours"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">

          <b-form-group
            label="Second Reviewer Avg Time In Hours"
            label-for="Second Reviewer Avg Time In Hours"
          >
            <b-form-input
              id="second_reviewer_avg_time_in_hours"
              v-model="certificateData.second_reviewer_avg_time_in_hours"
              trim
              type="number"
              placeholder="Second Reviewer Avg Time In Hours"
            />

          </b-form-group>
        </b-col>
        <b-col md="6">

          <b-form-group
            label="Data Entry Avg Time In Hours"
            label-for="Data Entry Avg Time In Hours"
          >
            <b-form-input
              id="data_entry_avg_time_in_hours"
              v-model="certificateData.data_entry_avg_time_in_hours"
              trim
              type="number"
              placeholder="Data Entry Avg Time In Hours"
            />

          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        class="bg-light py-2 px-2 rounded"
      >
        <b-row
          v-for="(report, index) in localReports"
          :key="index"
          class="w-100"
        >
          <b-col
            md="6"
          >
            <b-form-group
              :label="`Name Report ${index + 1}`"
              :label-for="`name-report-${index}`"
            >
              <b-form-input
                :id="`name-report-${index}`"
                v-model="report.name"
                trim
                placeholder="Enter report name"
                disabled
              />
            </b-form-group>
          </b-col>
          <b-col

            md="6"
          >
            <b-form-group
              :label="`Attach File for Report ${index + 1}`"
              :label-for="`file-report-${index}`"
            >
              <b-form-file
                :id="`file-report-${index}`"
                v-model="report.file"
              />
              <div
                class="text-success"
              >
                <a
                  :href="report.link"
                  target="_blank"
                >{{ report.link }}</a>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-row>

      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            @click="editCertificate"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            /> Loading...
          </b-button>
        </b-col>
      </b-row>
    </span>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  data() {
    return {
      required,
      errors: {},
      loader: false,
      dataLoad: false,
      localReports: [],
      optionRequireApprove: [
        { value: 0, text: ' ❌ false' },
        { value: 1, text: ' ✅ true' },
      ],
      optionNeedDataentry: [
        { value: 0, text: ' ❌ false' },
        { value: 1, text: ' ✅ true' },
      ],
      optionsProcessType: [
        { value: 'audit', text: 'audit' },
        { value: 'inspection', text: 'inspection' },
        { value: 'null', text: 'study' },
      ],
    }
  },
  setup() {
    const certificateData = ref({
      faqs: [],
      standard: [],
    })
    return {
      certificateData,
    }
  },
  computed: {
    optionsReports() {
      return this.$store.getters['generalData/reports/reportsList']
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/reports/reportsListLoaded']) {
      this.localDataLoad = true
      await this.$store.dispatch('generalData/reports/fetchReportsList')
      this.localDataLoad = false
    }
    this.localReports = JSON.parse(JSON.stringify(this.optionsReports))
    this.showCertificate()
  },
  methods: {
    showCertificate() {
      if (this.$route.params.id) {
        this.dataLoad = true
        axios
          .get(
            `certificate/${this.$route.params.MCR_id}/${this.$route.params.id}`,
          )
          .then(res => {
            const cert = decryptData(res.data.payload).data.certificate
            // remove keys you don’t need
            delete cert.faqs
            delete cert.faq_text
            delete cert.faq_text_ar
            delete cert.faq_text_en
            delete cert.product
            delete cert.standard
            delete cert.reports_files
            delete cert.certificate_type_id
            delete cert.components
            delete cert.engineers_info
            delete cert.certificate_group_id
            delete cert.certificate_category_id

            this.certificateData = cert
            const reportsFiles = decryptData(res.data.payload).data.certificate.reports_files || []
            if (reportsFiles.length > 0) {
              const updatedReports = this.optionsReports.map(report => {
                const matched = reportsFiles.find(r => r.report_name === report.name)
                return {
                  ...report,
                  file: null,
                  link: matched ? matched.file : report.link,
                }
              })

              this.localReports = updatedReports
            }
          }).finally(() => {
            this.dataLoad = false
          })
      }
    },
    editCertificate() {
      this.loader = true
      const formData = new FormData()

      Object.keys(this.certificateData).forEach(key => {
        if (Array.isArray(this.certificateData[key])) {
          this.certificateData[key].forEach((file, index) => {
            formData.append(`${key}[${index}]`, file)
          })
        } else if (typeof this.certificateData[key] === 'object' && this.certificateData[key] !== null) {
          formData.append(key, JSON.stringify(this.certificateData[key]))
        } else {
          formData.append(key, this.certificateData[key])
        }
      })

      // Append reports_files data
      this.localReports.forEach((report, index) => {
        if (report.file) {
          formData.append(`reports_files[${index}][report_name]`, report.name)
          formData.append(`reports_files[${index}][file]`, report.file)
        }
      })

      formData.append('_method', 'PUT')
      axios
        .post(
          `certificate/${this.$route.params.MCR_id}/${this.$route.params.id}`,
          formData,
        )
        .then(res => {
          this.$router.push({ name: 'certificate' })
          this.$toast({
            component: ToastificationContent,
            props: {
              title:
            res.status === 200
              ? 'Updated Successfully'
              : 'Created Successfully',
              icon: 'BellIcon',
              variant: 'success',
            },
          })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.response.data.message,
              icon: 'BellIcon',
              variant: 'error',
            },
          })
        })
        .finally(() => {
          this.loader = false
        })
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
